import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../../_services/user/authentication/authentication.service";
import {DBkeys} from "../../_services/user/authentication/dbkeys.service";
import {LocalStoreManagerService} from "../../_services/user/authentication/local-store-manager.service";
import {User} from "../../_models";

@Component({
    selector: 'wfdss-mimic-roles',
    templateUrl: './mimic-roles.component.html',
    styleUrls: ['./mimic-roles.component.scss'],
    standalone: false
})
export class MimicRolesComponent implements OnInit {
    selectedRole: string;

    constructor(private authenticationService: AuthenticationService,
                private localStorage: LocalStoreManagerService) {
    }

    ngOnInit(): void {
        this.selectedRole = this.authenticationService.currentUser.role.roleType;
    }

    mimicRole() {
        const user: User = JSON.parse(JSON.stringify(this.authenticationService.currentUser));
        user.role.roleType = this.selectedRole;
        this.localStorage.savePermanentData(user, DBkeys.CURRENT_USER);
    }
}
